import { render, staticRenderFns } from "./RectificationForm.vue?vue&type=template&id=364dc213&scoped=true"
import script from "./RectificationForm.vue?vue&type=script&lang=js"
export * from "./RectificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364dc213",
  null
  
)

export default component.exports